import {
  appendDefaultLocale,
  GetSectionsDocument,
  type GetSectionsQuery,
} from '@seek/cmsu-cms-connect';
import type { LoaderFunction } from 'react-router';

import { getHygraphLocales } from 'src/client/shared/utils/helper';
import { getPreviewProps } from 'src/helpers/loadersHelper';

import type { RouteProps } from '../routes';

export const sectionsLoader =
  ({ client, config }: RouteProps): LoaderFunction =>
  async ({}) => {
    const { section, hygraphLocale, isDraft } = config;

    const previewProps = getPreviewProps(isDraft);

    const where = {
      OR: [{ sectionName: section }],
    };

    const variables = {
      where,
      stage: previewProps.stage,
      locales: getHygraphLocales(hygraphLocale),
      localesWithDefault: appendDefaultLocale(getHygraphLocales(hygraphLocale)),
    };

    const { data } = await client.query<GetSectionsQuery>({
      query: GetSectionsDocument,
      variables,
      fetchPolicy: 'network-only',
    });
    return data;
  };
